export const CTA_LABEL = 'Learn More';
